import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { StoryblokComponent, storyblokEditable } from '@storyblok/react';
import React, { memo } from 'react';

import { withBaseComponent } from '../hoc/withBaseComponent';

const StoryblokGridItemComponent = ({ blok, baseStyles, annualPassIsValid }) => {
  const {
    general = {
      content: [],
      size: {
        mobile: 12,
        tablet: 12,
        desktop: 12,
      },
      orientation: 'column',
      gap: 4,
    },
    extra = { id: '' },
  } = blok;
  const { content, size, orientation, gap, justifyContent = 'flex-start' } = general;
  const { id } = extra;

  return (
    <Grid
      id={id}
      size={{
        lg: parseInt(size.desktop),
        md: parseInt(size.tablet),
        sm: parseInt(size.tablet),
        xs: parseInt(size.mobile),
      }}
      {...storyblokEditable(blok)}
      key={blok._uid}
      sx={{
        display: 'flex',
        flexDirection: orientation,
        gap: parseInt(gap),
        justifyContent,
        ...baseStyles,
      }}
    >
      {content.map((nestedBlok) => (
        <Box key={nestedBlok._uid}>
          <StoryblokComponent
            annualPassIsValid={annualPassIsValid}
            blok={nestedBlok}
            key={nestedBlok._uid}
          />
        </Box>
      ))}
    </Grid>
  );
};

StoryblokGridItemComponent.displayName = 'StoryblokGridItem';
const StoryblokGridItem = memo(StoryblokGridItemComponent);
// Stays a direct MUI Grid child — apply alignment to its own flex (centres its
// content) instead of being wrapped in a Box by withBaseComponent.
StoryblokGridItem.handlesAlignItems = true;

export default withBaseComponent(StoryblokGridItem);
